import { Dialog, Backdrop, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import './SurveyDialog.css';
import { useTranslation } from "react-i18next";

function SurveyDialog({
  isOpen,
  isLoading,
  close,
  error,
  confirm,
  children
}) {

  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: '#fff', backgroundColor: `rgba(0, 0, 0, 0.9)`, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress
          color="inherit"
          sx={{
            width: '60px !important',
            height: '60px !important',
            color: '#ffffff !important'
          }}
        />
      </Backdrop>
    )
  }

  return (
    <Dialog
      open={isOpen}
      className="survey-dialog"
      fullWidth
      maxWidth="sm"
    >
      <style>{`
        .survey-dialog .survey-dialog-btn__container {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 12px;
          position: sticky;
          bottom: 0;
          background: #ffffff;
          padding: 12px 20px;
          border-top: 1px solid #eef2f6;
        }
        .survey-dialog .survey-dialog-btn {
          appearance: none;
          border: 1px solid #d0d5dd;
          background: #ffffff;
          color: #111827;
          padding: 10px 16px;
          border-radius: 10px;
          font-weight: 600;
          font-size: 14px;
          line-height: 1;
          cursor: pointer;
          transition: box-shadow 120ms ease, transform 60ms ease, background 120ms ease, border-color 120ms ease;
          box-shadow: 0 1px 1px rgba(16, 24, 40, 0.04);
        }
        .survey-dialog .survey-dialog-btn:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
          box-shadow: 0 2px 6px rgba(16, 24, 40, 0.06);
        }
        .survey-dialog .survey-dialog-btn:active {
          transform: translateY(1px);
        }
        .survey-dialog .survey-dialog-btn:focus-visible {
          outline: 3px solid rgba(39, 174, 96, 0.35);
          outline-offset: 2px;
        }
        .survey-dialog .survey-dialog-btn.btn-confirm {
          background: #20c9ff;
          border-color: #20c9ff;
          color: #ffffff;
        }
        .survey-dialog .survey-dialog-btn.btn-confirm:hover {
          background: #04abe2ff;
          border-color: #04abe2ff;
        }
        .survey-dialog .survey-dialog-btn.btn-confirm:disabled,
        .survey-dialog .survey-dialog-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      `}</style>

      <div className="survey-dialog__container">
        <div className='survey-dialog__toolbar'>
          <CloseIcon onClick={close} />
        </div>
        <div className='survey-dialog__content'>
          <div className='survey-dialog__selection'>
            {error || children}
          </div>
        </div>
        <div className='survey-dialog-btn__container'>
          {error ? undefined :
            (
              <>
                <button onClick={close} className='survey-dialog-btn btn'>
                  {t('survey.compare.buttonCancel')}
                </button>
                <button onClick={confirm} className='survey-dialog-btn btn btn-confirm'>
                  {t('survey.compare.buttonConfirm')}
                </button>
              </>
            )}
        </div>
      </div>
    </Dialog>
  );
}

export default SurveyDialog;